import { render, staticRenderFns } from "./LeaderboardAveragePointsChart.vue?vue&type=template&id=597feaec"
import script from "./LeaderboardAveragePointsChart.vue?vue&type=script&lang=js"
export * from "./LeaderboardAveragePointsChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports